import React from "react";
import { Grid, Typography, makeStyles, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    marginBottom: theme.spacing(4),
    width: "95%",
  },
  legendRow: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: theme.spacing(3),
    marginLeft: theme.spacing(4),
    width: "100%",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    width: "auto",
    minWidth: 150,
    maxWidth: 240,
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1.5),
  },
  colorBox: {
    height: 15,
    width: 15,
    borderRadius: 2,
  },
  labelText: {
    wordBreak: "break-word",
    whiteSpace: "normal",
    flex: 1,
  },
}));

export default function Legend({ legends }) {
  const classes = useStyles();

  return (
    <div className={classes.legendContainer}>
      <div className={classes.legendRow}>
        {legends.map((item, index) => (
          <div className={classes.legendItem} key={index}>
            <div
              className={classes.colorBox}
              style={{ backgroundColor: item.backward_color_hash }}
            />
            <Typography variant="body2" className={classes.labelText}>
              {item.stage_name}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
}


// OLD Styled LEGENDS

// import { Grid, makeStyles, Typography } from "@material-ui/core";
// import React from "react";
// import Box from "@material-ui/core/Box";

// // const useStyle = makeStyles((theme) => ({
// //   square: {
// //     height: 10,
// //     width: 10,
// //   },
// // }));
// export default function Legend(props) {
//   const { legends } = props;
//   // const classes = useStyle();
//   return (
//     // <Grid container justifyContent="left" style={{ marginLeft: "8rem" }}>
//     //   {legends.map((item, i) => (
//     //     <Grid key={i} item xs={4}>
//     //       <Grid
//     //         item
//     //         style={{
//     //           marginTop:
//     //             legends.length >= 6
//     //               ? "2.2rem"
//     //               : item.stage_name.length > 20
//     //               ? "2.2rem"
//     //               : "1.5rem",
//     //         }}
//     //       >
//     //         <Grid
//     //           item
//     //           style={{
//     //             height: 15,
//     //             width: 15,
//     //             background: item.backward_color_hash,
//     //           }}
//     //         >
//     //           <Grid
//     //             item
//     //             style={{
//     //               width: "10rem",
//     //             }}
//     //           >
//     //             <Box display="flex" style={{ width: "11rem" }}>
//     //               <Typography style={{ marginLeft: "2rem" }}>
//     //                 {item.stage_name}
//     //                 {console.log("length_check", legends.length)}
//     //               </Typography>
//     //             </Box>
//     //           </Grid>
//     //         </Grid>
//     //       </Grid>
//     //     </Grid>
//     //   ))}
//     // </Grid>
//     <div style={{ marginBottom: "2rem", width: "95%" }}>
//       <div
//         style={{
//           flexDirection: "row",
//           display: "flex",
//           flexWrap: "wrap",
//           marginLeft: "2rem",
//           // justifyContent: "center",
//           justifyContent: "space-around",
//           width: "100%",
//         }}
//       >
//         {legends.map((item, i) => (
//           <div
//             style={{
//               flexDirection: "row",
//               width: "11rem",
//               // justifyContent: "space-around",
//               marginBottom: item.stage_name.length > 15 ? "3rem" : "auto",
//               // marginBottom: "3rem",
//             }}
//           >
//             <Grid item xs={2}>
//               <div
//                 style={{
//                   height: 15,
//                   width: 15,
//                   background: item.backward_color_hash,
//                 }}
//               >
//                 <Box
//                   display="flex"
//                   style={
//                     legends.length >= 7
//                       ? { width: "10rem" }
//                       : {
//                           // width: "16rem",
//                           minWidth: "11rem",
//                           maxWidth: "16rem",
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }
//                   }
//                 >
//                   <Typography style={{ marginLeft: "2rem" }}>
//                     {item.stage_name}
//                   </Typography>
//                 </Box>
//               </div>
//             </Grid>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }
